import React from 'react';
import type { OptionProps } from '@usealloy/component-library';
import { MultiSelectComponents } from '@usealloy/component-library';
import type { ActionTypeOption } from '../types';
import { StyledDropdownComponentText } from './styles';


interface AddLinkedChildActionTypeSingleValueProps extends OptionProps<ActionTypeOption, false> { }
export default function AddLinkedChildActionTypeSingleValue(
  props: AddLinkedChildActionTypeSingleValueProps,
) {
  const {
    data: {
      label,
      meta: {
        singleValueLabel,
      } = {},
    },
  } = props;

  return (
    <MultiSelectComponents.SingleValue {...props}>
      <StyledDropdownComponentText>
        {singleValueLabel ?? label}
      </StyledDropdownComponentText>
    </MultiSelectComponents.SingleValue>
  );
}
